import React from 'react';
import {createStyles, makeStyles, Theme} from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        },
        progress: {
            margin: theme.spacing(2)
        },
    }),
);

export default function Loader() {
    const classes = useStyles();

    const render = (
        <div className={classes.root}>
            <CircularProgress disableShrink={true} className={classes.progress}/>
        </div>
    );

    return render;
}